import { MapBoxStyleSpecService } from '../../../carried-over-from_1.10/mapbox-style-spec.service';
import {
  VectorStyle,
  VectorStyleLayer
} from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../twc-products';

const TWC_WEATHER_TROPICAL_STORM_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    layout: {},
    paint: {
      'line-color': '#858585',
      'line-width': 4
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'historic-track',
    filter: ['==', 'stormFeatureType', 'HistoricTrack'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {},
    paint: {
      'fill-color': '#22FFCC',
      'fill-outline-color': '#007BFF',
      'fill-opacity': 0.6
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'projected-cone-1',
    filter: ['==', 'stormFeatureType', 'ProjectedCone'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: {
      'line-color': '#22FFCC',
      'line-width': 2,
      'line-dasharray': [2, 2]
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'projected-track',
    filter: ['==', 'stormFeatureType', 'ProjectedTrack'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {
      'icon-image': [
        'case',
        ['>', ['get', 'max_sustained_wind'], 1],
        [
          'case',
          ['<', ['get', 'max_sustained_wind'], 33],
          'Trop Depression CIrcle',
          ['>', ['get', 'max_sustained_wind'], 64],
          [
            'case',
            [
              'in',
              'N',
              MapBoxStyleSpecService.getAttributeFromCompositeObject(
                'storm_dir_cardinal',
                'heading'
              )
            ],
            'Tropical Northern Severe',
            'Tropical Southern Severe'
          ],
          [
            'in',
            'N',
            MapBoxStyleSpecService.getAttributeFromCompositeObject(
              'storm_dir_cardinal',
              'heading'
            )
          ],
          'Tropical Northern',
          'Tropical Southern'
        ],
        ''
      ],
      'icon-size': 0.3,
      'icon-rotate': MapBoxStyleSpecService.getAttributeFromCompositeObject(
        'storm_dir',
        'heading'
      ),
      'text-field': [
        'case',
        ['>', ['get', 'max_sustained_wind'], 1],
        [
          'concat',
          ['coalesce', ['get', 'storm_name'], ''],
          '\n',
          ['slice', ['get', 'adv_dt_tm'], 8, 10],
          '/',
          ['slice', ['get', 'adv_dt_tm'], 11, 13],
          ['slice', ['get', 'adv_dt_tm'], 14, 16],
          'Z\n',
          ['to-string', ['get', 'max_sustained_wind']],
          ' kts'
        ],
        ''
      ],
      'text-size': 10,
      'icon-allow-overlap': true,
      'text-allow-overlap': false,
      'text-offset': [4, 0],
      'text-variable-anchor': ['left', 'right']
    },
    paint: {
      'text-color': '#000000',
      'text-halo-color': '#ffffff',
      'text-halo-width': 2
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'forecast-positions',
    filter: ['==', 'ForecastPosition', 'CurrentPosition', 'HistoryPosition'],
    type: 'symbol',
    maxzoom: 28
  }
];

export const TWC_WEATHER_TROPICAL_STORM_VECTOR_STYLE: VectorStyle = {
  layers: TWC_WEATHER_TROPICAL_STORM_VECTOR_STYLE_LAYERS,
  sprite: `assets/weather/sprites/StormTracks/Tropical-Storm-Tracks`,
  glyphs: `assets/weather/glyphs/Font11_Regular/0-255.pbf`
};

export const WEATHER_TROPICAL_STORM_PRODUCT_DATA: TwcProduct = {
  id: 'tropical-cyclone-tracks',
  defaultProductId: '9066',
  productName: 'Weather-Tropical-Storm-Tracks-TWC',
  label: 'Tropical Cyclone Tracks',
  weatherType: 'TROPICAL_STORM_TRACKS',
  description: 'TWC product (vector) - Global Tropical Storm Tracks',
  series: 'Observation',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 85,
  layerSpecs: {
    vectorTile: { vectorStyle: TWC_WEATHER_TROPICAL_STORM_VECTOR_STYLE }
  }
};
